const apiPaths = {
  promotionPricingAll: '/groups/forever-print-artisan-products/primary_promotion',
  group: '/groups/:slug/marketing',
  groupDetails: '/groups/:slug/',
  groupPromotions: '/groups/:slug/primary_promotion',

  //cart
  lineItems: '/line_items',
  orderAdjustments: '/order_adjustments' //post to add a promotion code
};

// Best effort - a code the cart refuses must not fail the add to cart it follows.
async function applyPromotionCode(code) {
  try {
    await useStoreApi().post(apiPaths.orderAdjustments, {
      body: {code}
    });
  } catch {
    //
  }
}

export function usePricingApi() {
  return {
    async getPromotionPricing() {
      const data = await useStoreApi().fetch(apiPaths.promotionPricingAll);
      const promotions  = data.group?.products;

      return promotions?.filter(item => item.primary_promotion && Object.keys(item.primary_promotion).length);
    },

    async getGroupProducts({groupSlug, includeDescriptions = false}) {
      const data = await useStoreApi().fetch(apiPaths.group, {
        params: {
          route: {slug: groupSlug},
          ...(includeDescriptions
            ? {query: {include_descriptions: true}}
            : {})
        }
      });
      return data.group?.products;
    },

    // The group itself - `primary_promotion` here is the GROUP'S promotion, not a product's.
    async getGroup({groupSlug}) {
      const data = await useStoreApi().fetch(apiPaths.groupDetails, {
        params: {
          route: {slug: groupSlug}
        }
      });
      return data.group;
    },

    async getGroupPromotions({groupSlug}) {
      const data = await useStoreApi().fetch(apiPaths.groupPromotions, {
        params: {
          route: {slug: groupSlug}
        }
      });
      return data.group?.products;
    },

    async addToCart({productId, quantity = 1, optionValues = [], requiredLineItemsAttributes = [], promotionCode, additionalAttributes = {}, gift}) {
      const payload = {
        product_id: productId,
        quantity,
        line_item_option_values_attributes: optionValues,
        required_line_items_attributes: requiredLineItemsAttributes,
        gift,
        ...additionalAttributes
      };

      const response = await useStoreApi().post(apiPaths.lineItems, {
        body: payload
      });

      if (promotionCode) {
        await applyPromotionCode(promotionCode);
      }

      return response;
    },

    applyPromotionCode
  }
}

